export default "__VITE_ASSET__BOMM86PK__"